<template>
  <div class="page-template">
    <div class="page-title">{{ title }}</div>
      <search-form-template
        :searchOptions="searchOptions"
        :toolConfig="toolConfig"
      ></search-form-template>
      <table-template ref="store" :tableOptions="storeReportTable">
      </table-template>
  </div>
</template>

<script>
import api from "@/config/api";
import searchFormTemplate from "@/components/template/searchFormTemplate";
import tableTemplate from "@/components/template/tableTemplate";
import echartsTemplate from "@/components/controls/echarts";
import { reportConsumptionSummary } from "@/page/home/options/reportEcharts";
export default {
  components: { searchFormTemplate, tableTemplate, echartsTemplate },
  data() {
    return {
      reportConsumptionSummary,
      title: "",
      indexShow: false,
      //按门店
      searchOptions: {
        simple: [
          {
            label: "使用积分门店",
            prop: "orderNo",
            type: "select",
            url: api.system.seStore,
          },
        ],
        complex: [
          {
            label: "选择日期",
            prop: "CreateDttm",
            type: "dateTimeRangeButton",
            dateType: "datetime",
            span: 24,
          },
          {
            label: "使用类型",
            prop: "orderNo",
            type: "select",
            span:12,
            url: api.system.seStore,
          },
        ],
      },
      storeReportTable: {
        indexShow: true, //是否显示索引
        param: { type: 10 },
        columns: [
          {
            label: "门店名称",
            prop: "storeName",
            width: "100",
            align: "center",
          },
          {
            label: "会员",
            prop: "inventoryNum",
            width: "100",
            align: "center",
          },
          {
            label: "使用类型",
            prop: "retailMoney",
            width: "100",
            align: "center",
          },
          {
            label: "使用积分数",
            prop: "purchaseMoney",
            width: "100",
            align: "center",
          },
          {
            label: "备注",
            prop: "purchaseMoney",
            width: "100",
            align: "center",
          },
          {
            label: "使用时间",
            prop: "purchaseMoney",
            width: "100",
            align: "center",
          },
        ],
        url: api.report.reportStatical,
      },
      toolConfig: [
        {
          label: "导出",
          code: "export",
        },
      ],
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    this.title = document.title;
  },
  methods: {
    getData() {
      // console.log(this)
      this.$axios
        .fetchPost(api.report.SummaryEcharts, { type: 10 })
        .then((data) => {
          if (data.code == 200) {
            console.log(data.data);
            this.reportConsumptionSummary.charsOption.xAxis[0].data =
              data.data.time;
            this.reportConsumptionSummary.charsOption.series[0].data =
              data.data.money;
            this.reportConsumptionSummary.charsOption.series[1].data =
              data.data.number;
            this.$nextTick(() => {
              this.$refs.reportConsumptionSummary.drawpic();
            });
          }
        })
        .catch((err) => {
          this.$message({ message: "请求失败！", type: "error" });
        });
    },
  },
};
</script>

<style scoped>
.page-template .centerBack {
  background: #fff;
  border-radius: 8px;
  padding: 25px;
}
.page-template .echartsArea {
  height: 270px;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/page/report/member/integral/Use.vue